var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeamlessExperience(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0001 16C13.8956 16 13.0001 16.8954 13.0001 18V33.7143C13.0001 34.8189 13.8956 35.7143 15.0001 35.7143H71.0001C72.1047 35.7143 73.0001 34.8189 73.0001 33.7143V18C73.0001 16.8954 72.1047 16 71.0001 16H15.0001ZM21.214 22.7139C20.9378 22.7139 20.714 22.9377 20.714 23.2139C20.714 23.49 20.9378 23.7139 21.214 23.7139H35.6426C35.9187 23.7139 36.1426 23.49 36.1426 23.2139C36.1426 22.9377 35.9187 22.7139 35.6426 22.7139H21.214ZM20.714 28.3574C20.714 28.0813 20.9378 27.8574 21.214 27.8574H54.4997C54.7758 27.8574 54.9997 28.0813 54.9997 28.3574C54.9997 28.6336 54.7758 28.8574 54.4997 28.8574H21.214C20.9378 28.8574 20.714 28.6336 20.714 28.3574ZM40.9288 22.7139C40.6527 22.7139 40.4288 22.9377 40.4288 23.2139C40.4288 23.49 40.6527 23.7139 40.9288 23.7139H64.786C65.0621 23.7139 65.286 23.49 65.286 23.2139C65.286 22.9377 65.0621 22.7139 64.786 22.7139H40.9288Z",
    fill: "url(#paint0_linear_79_1141)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 16,
    width: 60,
    height: 19.7143,
    rx: 2,
    stroke: "#302F3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 41.1436C13 40.039 13.8954 39.1436 15 39.1436H71C72.1046 39.1436 73 40.039 73 41.1436V48.579C66.8846 48.7727 61.8119 53.0992 60.4827 58.8578H15C13.8954 58.8578 13 57.9624 13 56.8578V41.1436ZM20.7139 46.3574C20.7139 46.0813 20.9377 45.8574 21.2139 45.8574H48.4996C48.7757 45.8574 48.9996 46.0813 48.9996 46.3574C48.9996 46.6336 48.7757 46.8574 48.4996 46.8574H21.2139C20.9377 46.8574 20.7139 46.6336 20.7139 46.3574ZM21.2139 51.001C20.9377 51.001 20.7139 51.2248 20.7139 51.501C20.7139 51.7771 20.9377 52.001 21.2139 52.001H54.4996C54.7757 52.001 54.9996 51.7771 54.9996 51.501C54.9996 51.2248 54.7757 51.001 54.4996 51.001H21.2139ZM53.2861 46.3574C53.2861 46.0813 53.51 45.8574 53.7861 45.8574L64.7861 45.8574C65.0623 45.8574 65.2861 46.0813 65.2861 46.3574C65.2861 46.6336 65.0623 46.8574 64.7861 46.8574L53.7861 46.8574C53.51 46.8574 53.2861 46.6336 53.2861 46.3574Z",
    fill: "url(#paint1_linear_79_1141)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73 49.0007V41.1436C73 40.039 72.1046 39.1436 71 39.1436H15C13.8954 39.1436 13 40.039 13 41.1436V56.8578C13 57.9624 13.8954 58.8578 15 58.8578H43H61",
    stroke: "#302F3A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1493 62.2852H15C13.8954 62.2852 13 63.1806 13 64.2852V79.9994C13 81.104 13.8954 81.9994 15 81.9994H71C72.1046 81.9994 73 81.104 73 79.9994V75.1359C68.9053 75.0063 65.278 73.0237 62.929 69.999H40.9287C40.6526 69.999 40.4287 69.7752 40.4287 69.499C40.4287 69.2229 40.6526 68.999 40.9287 68.999H62.2236C60.9779 67.0489 60.2274 64.7518 60.1493 62.2852ZM20.7139 69.499C20.7139 69.2229 20.9377 68.999 21.2139 68.999H34.9618C35.2379 68.999 35.4618 69.2229 35.4618 69.499C35.4618 69.7752 35.2379 69.999 34.9618 69.999H21.2139C20.9377 69.999 20.7139 69.7752 20.7139 69.499ZM21.2139 74.1426C20.9377 74.1426 20.7139 74.3664 20.7139 74.6426C20.7139 74.9187 20.9377 75.1426 21.2139 75.1426H54.4996C54.7757 75.1426 54.9996 74.9187 54.9996 74.6426C54.9996 74.3664 54.7757 74.1426 54.4996 74.1426H21.2139Z",
    fill: "url(#paint2_linear_79_1141)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73 74.7137V79.9994C73 81.104 72.1046 81.9994 71 81.9994H15C13.8954 81.9994 13 81.104 13 79.9994V64.2852C13 63.1806 13.8954 62.2852 15 62.2852H43H60.5714",
    stroke: "#302F3A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.214 61.857C86.214 68.9184 80.4896 74.6427 73.4283 74.6427C66.3669 74.6427 60.6426 68.9184 60.6426 61.857C60.6426 54.7956 66.3669 49.0713 73.4283 49.0713C80.4896 49.0713 86.214 54.7956 86.214 61.857Z",
    fill: "url(#paint3_linear_79_1141)",
    fillOpacity: 0.5,
    stroke: "#AAECD8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9993 58L71.3386 65.7143L67.8564 62.2078",
    stroke: "#AAECD8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_1141",
    x1: 13.0001,
    y1: 16,
    x2: 35.0868,
    y2: 56.4274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30303A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30303A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_79_1141",
    x1: 13,
    y1: 39.1436,
    x2: 35.0867,
    y2: 79.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30303A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30303A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_79_1141",
    x1: 13,
    y1: 62.2852,
    x2: 35.0867,
    y2: 102.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30303A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30303A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_79_1141",
    x1: 73.4283,
    y1: 49.8999,
    x2: 73.4283,
    y2: 75.1427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAECD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAECD8",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeamlessExperience);
export default __webpack_public_path__ + "static/media/SeamlessExperience.a2f9ce49f49ec07030dfd7e9ee73e300.svg";
export { ForwardRef as ReactComponent };